import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MyprofileComponent } from './myprofile/myprofile.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { PaymentResultComponent } from './payment-result/payment-result.component';

const routes: Routes = [

  { path: '', component: MyprofileComponent },
  { path: 'producto/:id', component: ProductDetailComponent },
  { path: 'pago-resultado', component: PaymentResultComponent },
  { path: '**', redirectTo: '' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
